import type { AlarmLevel } from "@/components/AlarmManager";

export interface AlarmOzeti {
  level: AlarmLevel;
  criticalCount: number;
}

/**
 * Eski `legacy/js/app.js renderAlarm` portu: snapshot KPI'larindan genel
 * alarm seviyesi + kritik kayit sayisi. Donem filtresinden GECMIS kpis
 * verilmeli (kuyruk kartlari kirpildiktan sonra) — aksi halde "Bugün"
 * seciliyken tum-zamanlar kritikleri alarm caldirir.
 */
export function alarmFromKpis(kpis: Record<string, unknown> | null | undefined): AlarmOzeti {
  let critical = 0;
  let warning = false;
  for (const entry of Object.values(kpis ?? {})) {
    if (!entry || typeof entry !== "object") continue;
    const e = entry as { alarm_level?: unknown; critical_count?: unknown; count?: unknown };
    if (e.alarm_level === "critical") {
      const n = Number(e.critical_count);
      critical += Number.isFinite(n) && n > 0 ? n : Math.max(1, Number(e.count) || 0);
    } else if (e.alarm_level === "warning") {
      warning = true;
    }
  }
  if (critical > 0) return { level: "critical", criticalCount: critical };
  return { level: warning ? "warning" : "normal", criticalCount: 0 };
}
